import { t } from "i18next"
const lmsColumnsTransformer = resp => {
  const userColumns = resp?.length
    ? resp?.map(column => ({
        title: column?.ExternalInquiryDisplayColumn?.columnName,
        dataIndex: column?.ExternalInquiryDisplayColumn?.isAdditional
          ? `${column?.ExternalInquiryDisplayColumn?.columnKey}_additional`
          : column?.ExternalInquiryDisplayColumn?.columnKey,
        isAdditional: column?.ExternalInquiryDisplayColumn?.isAdditional,
      }))
    : [
        { title: t("INQUIRY ID"), dataIndex: "inquiryInfo", className: "tableStartSpaceExtra", width: 200 },
        { title: t("NAME"), dataIndex: "clientInfo", width: 140 },
        { title: t("Interest"), dataIndex: "Project", dataIndexFallback: "ExternalInquiryPartner", width: 140 },
        { title: t("CAMPAIGN"), dataIndex: "SocialPlatformCampaign", width: 180 },
        { title: t("STATUS"), dataIndex: "ExternalInquiryStatus", width: 100 },
        { title: t("POOL"), dataIndex: "InquiryPool", width: 120 },
        { title: t("ASSIGNEE"), dataIndex: "Assignee", width: 180 },
      ]
  userColumns.push({ title: t("ACTIONS"), dataIndex: "actions", width: 100 })

  const selectedColumnIds = resp?.map(item => item?.externalInquiryDisplayColumnId)
  return { userColumns, selectedColumnIds }
}

export default lmsColumnsTransformer
